import { useEffect, useRef } from 'react';

interface InViewHookParams {
  callback: () => void;
  options?: IntersectionObserverInit;
}

const DEFAULT_OPTIONS = {
  root: null,
  rootMargin: '0px',
  threshold: 0.2,
};

export const useInView = ({ callback, options = DEFAULT_OPTIONS }: InViewHookParams) => {
  const inviewRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        callback();
      }
    }, options);

    if (inviewRef.current) {
      observer.observe(inviewRef.current);
    }

    return () => {
      if (inviewRef.current) {
        observer.unobserve(inviewRef.current);
      }
    };
  });

  return { inviewRef };
};
